import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as Separator } from './Separator.vue'

// The orientation axis is the separator's only visual option: reka sets
// data-orientation from the same prop, so keying the recipe on the prop renders
// exactly what the attribute selectors rendered before.
export const separatorVariants = cva(
  'bg-border shrink-0',
  {
    variants: {
      orientation: {
        horizontal: 'h-px w-full',
        vertical: 'h-full w-px',
      },
    },
    defaultVariants: {
      orientation: 'horizontal',
    },
  },
)
export type SeparatorVariants = VariantProps<typeof separatorVariants>
